export default "__VITE_ASSET__BfuvBQo9__"